import { ApolloClient, InMemoryCache, ApolloLink } from '@apollo/client'

import { authLink, agentHttpLink, responseTimeLink } from '@/lib/apollo/links'

const client = new ApolloClient({
  link: ApolloLink.from([responseTimeLink, authLink, agentHttpLink]),
  cache: new InMemoryCache(),
})

export default client
